// extracted by mini-css-extract-plugin
export default {"EchoButton":"echo-button_EchoButton__xlXoA"};